module.exports = __webpack_public_path__ + "media/toolkits/check-circle-filled-719892a9.svg";